<template>
  <v-dialog
      v-model="dialog"
      persistent
      fullscreen
  >
    <v-card class="pb-3 pr-3">
      <v-card-title>
        <v-spacer></v-spacer>
        <v-btn @click="dialog = false" color="danger darken-1" style="color: white;">
          KAPAT
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div v-if="fileActionLoading" class="text-center">
          <v-overlay :value="fileActionLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
            <div>Dosya İşlemleriniz Devam Ederken Lütfen Bekleyiniz</div>
          </v-overlay>
        </div>
        <div v-else class="row">
          <div class="col-lg-12">
            <div class="card">
              <div style="border:1px solid #e9e9ec" class="card-body pb-3 pr-3">
                <div class="row">
                  <div class="p-0 col-xl-6 col-sm-12">
                    <div v-if="picsumImages.length<1" style="height: 500px" class="d-flex justify-content-center align-items-center">
                      <img style="width: 350px; height: 300px" src="../../../assets/images/no_image2.jpg" alt=""/>
                    </div>
                    <v-carousel
                        v-else
                        class="p-5"
                        style="height: 600px"
                        v-model="activeSlide"
                        interval="5000"
                        hide-delimiters
                    >
                      <v-carousel-item v-for="(item, i) in picsumImages" :key="i">
                        <img :src="item" :key="i" style="width: 100%; height: 100%; object-fit: cover; cursor: pointer;"
                             alt="" @click="expandImage(picsumImages)"/>
                      </v-carousel-item>
                    </v-carousel>
                    <div class="text-center">
                      <template>
                        <div class="text-center">
                          <template v-for="(item, i) in picsumImages">
                            <img
                                class="m-3"
                                :src="item"
                                :key="i"
                                style="height: 50px; width: 50px; cursor: pointer;"
                                @click="goToSlide(i)"
                                alt=""
                            />
                          </template>
                        </div>
                      </template>

                    </div>

                    <div v-if="user && user.RoleGroupId  === '1'"
                         class="pt-3 pr-10 pl-10 w-100 text-center col-lg-12">
                      <div class="row justify-content-center">
                        <v-file-input
                            class="col-lg-4 mr-10"
                            solo
                            filled
                            dense
                            clearable
                            multiple
                            v-model="selectedFile"
                            label="Dosya Eklemek için Tıklayn"
                            @change="onFileChange"
                        ></v-file-input>
                        <v-btn
                            class="col-lg-4"
                            :disabled="selectedFile.length<1"
                            color="success"
                            dense
                            filled
                            solo
                            height="41px"
                            @click="addImage"
                        >
                          <v-icon left>mdi-image</v-icon>
                          Dosya Yükle
                        </v-btn>
                      </div>
                    </div>
                  </div>


                  <div style="background-color: #f8f8fb" class="pl-7 pr-10 col-xl-5 col-sm-12">
                    <div>
                      <div class="row d-flex pt-6 mb-10">
                        <h2 class="mt-1 mb-3">{{ singleStock.name }}</h2>
                      </div>

                      <div class="row d-flex justify-content-center align-items-center">
                        <div class=" d-flex">
                          <h1 class="align-self-end mr-10">
                            {{ numberConverter(singleStock.vatIncludedUnitPrice) + ' ' + singleStock.currency }}</h1>
                          <h6 class="fs -6 align-self-end pb-1"> (Kdv Dahil)</h6>
                        </div>
                        <div class="mb-2 d-flex ">
                          <h3 class="fs-5 align-self-end mr-2">
                            {{ numberConverter(singleStock.vatExcludedUnitPrice) + ' ' + singleStock.currency }}</h3>
                          <h6 class="fs-6 align-self-end"> (Kdv Hariç) </h6>
                        </div>
                      </div>

                      <div class="row d-flex  align-items-center">
                        <div class="d-flex  col-xl-4 col-sm-4">
                          <b-button
                              class="my-1 me-2 align-self-center"
                              @click="changeQuantity('sub')"
                              x-small
                              :disabled="quantity < 2"
                          ><i class="mdi mdi-minus"></i
                          ></b-button>
                          <input
                              type="number"
                              :value="quantity"
                              :min="1"
                              class="form-control"
                              style="width: 80px"
                          />
                          <b-button
                              style="background-color: #34c38f; border-color: #34c38f"
                              class="my-1 ms-2 align-self-center"
                              x-small
                              @click="changeQuantity('add')"
                          ><i class="mdi mdi-plus"></i
                          ></b-button>
                        </div>
                        <div class="m-2 col-xl-5 col-sm-5"
                        >
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  color="warning darken-1"
                                  @click="addToCart(singleStock)"
                              >
                                <v-icon small left>mdi-basket-fill</v-icon>
                                Sepete Ekle
                              </v-btn>
                            </template>
                            <span>Ürünü Sepetinize Eklemek İçin Tıklayınız</span>
                          </v-tooltip>
                        </div>
                      </div>
                      <div class="row d-flex align-items-center">
                        <h6 class="pt-0 col-xl-4 col-sm-4">
                          Stok Durumu :
                          <b>{{ singleStock.balance }}</b>
                        </h6>
                      </div>
                      <div class="row d-flex align-items-center">
                        <h5 v-if="singleStock.code" class="col-xl-3">
                          Stok Kodu :
                          <b>{{ singleStock.code }}</b>
                        </h5>
                        <h5 v-if="singleStock.barcode1" class="col-xl-3">
                          Barkod 1 :
                          <b>{{ singleStock.barcode1 }}</b>
                        </h5>
                        <h5 v-if="singleStock.barcode2" class="col-xl-3">
                          Barkod 2 :
                          <b>{{ singleStock.barcode2 }}</b>
                        </h5>
                        <h5 v-if="singleStock.barcode3" class="col-xl-3">
                          Barkod 3 :
                          <b>{{ singleStock.barcode3 }}</b>
                        </h5>
                        <h5 v-if="singleStock.origin" class="col-xl-3">
                          Menşei :
                          <b>{{ singleStock.origin }}</b>
                        </h5>
                        <h5 v-if="singleStock.gtip" class="col-xl-3">
                          GTİP :
                          <b>{{ singleStock.gtip }}</b>
                        </h5>
                        <h5 v-if="singleStock.denominator1" class="col-xl-3">
                          Koli İçi Adet :
                          <b>{{ singleStock.denominator1 }}</b>
                        </h5>
                      </div>

                      <div class="row">
                        <div class="col-4 d-flex" v-if="user && user.RoleGroupId === '1'" >
                          <v-tooltip v-if="user && user.RoleGroupId === '1'" top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                  class="text-white flex-grow-1"
                                  v-bind="attrs"
                                  v-on="on"
                                  small
                                  color="cyan darken-2"
                                  @click="openStokOzellikDialog(singleStock)"
                              >
                                <v-icon small left>mdi-file-document-edit-outline</v-icon>
                                Stok Özellikleri
                              </v-btn>
                            </template>
                            <span>Düzenlemek için tıklayınız</span>
                          </v-tooltip>
                        </div>
                        <div class="col-12 d-flex" v-else>
                          <h5>Ürün Açıklaması : {{singleStock.property}} </h5>
                        </div>
                        <div class="d-flex" :class="user && user.RoleGroupId !== '1' ? 'col-6' : 'col-4' ">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                  class="text-white flex-grow-1"
                                  v-bind="attrs"
                                  v-on="on"
                                  small
                                  color="brown darken-2"
                                  @click="openStockActionListDialog(singleStock)"
                              >
                                <v-icon small left>mdi-file-document-edit-outline</v-icon>
                                Stok Hareketleri
                              </v-btn>
                            </template>
                            <span>Düzenlemek için tıklayınız</span>
                          </v-tooltip>
                        </div>
                        <div class="d-flex" :class="user && user.RoleGroupId !== '1' ? 'col-6' : 'col-4' ">
                          <v-tooltip v-if="user && user.RoleGroupId === '1'" top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                  class="text-white flex-grow-1"
                                  v-bind="attrs"
                                  v-on="on"
                                  small
                                  color="teal darken-1"
                                  @click="openMuadilKodDialog(singleStock)"
                              >
                                <v-icon small left>mdi-sticker-check-outline</v-icon>
                                Muadil Kod
                              </v-btn>
                            </template>
                            <span>Düzenlemek için tıklayınız</span>
                          </v-tooltip>
                        </div>
                      </div>
                      <div class="mt-5 col-lg-12 justify-content-center">
                        <div v-if="removeState"
                             class="pb-3 pr-3 pl-3 w-100 text-center row justify-content-center">
                          <b-table
                              bordered
                              small
                              :busy="singleStockLoading"
                              :fields="singleStockHeaders"
                              :items="singleStock.files"
                              hover
                              responsive
                              style="font-size:10px;"
                              head-row-variant="info"
                              table-variant="white"
                          >
                            <template #cell(fileUrl)="data">
                              <a target="_blank" :href="data.item.fileUrl">{{ findItemName(data.item) }}</a>
                            </template>
                            <template #cell(process)="data">
                              <div class="text-center">
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn @click="removeFile(data.item)" v-bind="attrs" v-on="on" icon
                                           :disabled = "user && user.RoleGroupId !== '1'"
                                           color="danger darken-2">
                                      <v-icon>mdi-delete-outline</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Sil</span>
                                </v-tooltip>
                              </div>
                            </template>
                          </b-table>
                        </div>
                        <div class="row justify-content-center mb-5">
                          <v-btn
                              v-if="!removeState"
                              class="col-lg-6"
                              :disabled="otherLinks.length<1 && picsumImages.length<1"
                              color="warning"
                              small
                              @click="removeState = !removeState"
                          >
                            <v-icon left>mdi-file</v-icon>
                            Dosyaları Gör
                          </v-btn>
                          <v-btn
                              v-if="removeState"
                              class="col-lg-6"
                              color="warning"
                              small
                              @click="removeState = !removeState"
                          >
                            <v-icon left>mdi-file</v-icon>
                            Kapat
                          </v-btn>
                        </div>
                      </div>

                    </div>

                  </div>

                  <!--
                  <div class="d-flex flex-wrap">
                    <v-btn
                        color="success"
                        small
                        outlined
                    >
                      <v-icon left>mdi-basket-outline</v-icon>
                      Sepete Ekle
                    </v-btn>
                    <v-btn
                        color="secondary"
                        small
                        outlined
                        class="mx-2"
                    >
                      <v-icon left> mdi-file-document-edit-outline</v-icon>
                      Stok Özellikleri Düzenle
                    </v-btn>

                    <v-btn
                        color="info"
                        small
                        outlined
                        class="mx-2"
                    >
                      <v-icon left> mdi-sticker-check-outline</v-icon>
                      Muadil Kod Düzenle
                    </v-btn>

                  </div>
                  -->

                </div>
                <!-- <div class="mt-5">
                  <h5 class="mb-3">Tüm Özellikler :</h5>

                  <div class="table-responsive">
                    <table class="table mb-0 table-bordered">
                      <tbody>
                      <tr

                      >
                        <th scope="row" style="width: 400px">Ürün Adı</th>
                        <td>SANDVİÇ MİNİ KEMİK ÖDÜL (6 AD*350 GR)</td>
                      </tr>
                      <tr

                      >
                        <th scope="row" style="width: 400px">Stok Kodu</th>
                        <td>AL-101</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div> -->


                <!-- end Specifications -->
              </div>
            </div>
            <!-- end card -->
          </div>
        </div>
        <!-- end row -->
        <MuadilKodDialog
            :title="'Muadil Kod Düzenle'"
            :showDialog="muadilKodDialog"
            @dialogChange="(e) => (muadilKodDialog = e)"
            :product="muadilKodDialogData"
        ></MuadilKodDialog>
        <StokOzellikDialog
            :title="'Stok Özelliği'"
            :showDialog="stokOzellikDialog"
            @dialogChange="(e) => (stokOzellikDialog = e)"
            :product="stokOzellikDialogData"
        ></StokOzellikDialog>
        <StockActionsDialog
            :showDialog="showStockActionsDialog"
            :stockCodeProp="stockCodeProp"
            :currentCodeProp="currentCodeProp"
            @dialogChange="(e) => (showStockActionsDialog = e)"
        ></StockActionsDialog>
        <ProductImageGalleryDialog
            :showDialog="showProductImageGalleryDialog"
            :stockCodeProp="stockCodeProp"
            :currentCodeProp="currentCodeProp"
            @dialogChange="(e) => (showProductImageGalleryDialog = e)"
        >
        </ProductImageGalleryDialog>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import {numberConverter} from "../../../../helpers";
import {mapActions, mapState} from "vuex";
import Swal from "sweetalert2";
import MuadilKodDialog from "@/components/product-search/dialogs/MuadilKodDialog";
import StokOzellikDialog from "@/components/product-search/dialogs/StokOzellikDialog";
import StockActionsDialog from "@/components/product-search/dialogs/StockActionsDialog";
import ProductImageGalleryDialog from "@/components/product/ProductImageGalleryDialog";
import axios from "axios";
import store from "@/state/store";

export default {
  name: "ProductDetail",
  components: {
    MuadilKodDialog,
    StokOzellikDialog,
    StockActionsDialog,
    ProductImageGalleryDialog
  },
  computed: {
    ...mapState('stock', ['singleStock', "singleStockHeaders", "singleStockLoading"]),
    ...mapState('auth', ['user']),
    ...mapState("cart", ["cartList", "current"]),
  },
  props: {
    stockCode: {
      type: String,
      default: "",
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      quantity: 1,
      activeSlide: 0,
      dialog: false,
      breadcrumbArray: [
        {
          text: "Ürün Detay",
          active: true,
        },
      ],
      otherLinks: [],
      picsumImages: [],
      muadilKodDialog: false,
      muadilKodDialogData: null,
      stokOzellikDialog: false,
      stokOzellikDialogData: null,
      showStockActionsDialog: false,
      stockCodeProp: null,
      currentCodeProp: null,
      muadilKodluUrunList: [],
      showProductImageGalleryDialog: false,
      selectedFile: [],
      imageUrl: null,
      imageAction: true,
      changedImage: null,
      fileActionLoading: false,
      removeState: false,
    }
  },
  mounted() {
    // this.fetchSingleStock({
    //   // Bu kısımda kişinin role groupuna göre parametre eklemesi yapılacaktır
    //   params: {
    //     userId: this.user.UserId,
    //     stockCode: this.$route.params.stockCode
    //   },
    //   body: {}
    // });
    // this.getMuadilKodluUrunList();
    this.loadImages();
  },
  methods: {
    ...mapActions('stock', ['fetchSingleStock', 'fetchStockList', 'stockImageDelete']),
    ...mapActions("cart", ["cartStockUpdate", "cartStockUpdate", "cartStockDelete", "stockToCartAdd"]),
    numberConverter,
    findItemName(item) {
      const url = new URL(item.fileUrl);
      const pathname = url.pathname;
      return pathname.split('/').pop();
    },
    async removeFile(item) {
      this.fileActionLoading = true;
      await this.stockImageDelete({
        params: {},
        body: {},
        urlSegments: [item.id],
      });
      await this.fetchSingleStock({
        params: {
          stockCode: this.singleStock.code
        },
        body: {}
      });
      // await this.getMuadilKodluUrunList();
      await this.loadImages();
      this.fileActionLoading = false;
    },
    async addImage() {
      const ipAdress = localStorage.getItem("ipAddress");
      const port = localStorage.getItem("port");

      let formData = new FormData();
      this.selectedFile.forEach((file, index) => {
        formData.append(`post[files][${index}]`, file)
      })
      formData.append('method', 'POST');
      formData.append('url', `http://${ipAdress}:${port}/api/v1/stock/file/add?userId=${this.user.UserId}&stockCode=${this.singleStock.code}`);
      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `https://${window.location.host}/api/redirect`,
        headers: {
          'Authorization': "Bearer " + store.state.auth.token,
          'content-type': 'multipart/form-data',
        },
        data: formData
      };
      this.fileActionLoading = true;
      await axios.request(config).then(async () => {
        await this.fetchSingleStock({
          params: {
            stockCode: this.singleStock.code
          },
          body: {}
        });
        // await this.getMuadilKodluUrunList();
        await this.loadImages();
        this.selectedFile = [];
        this.fileActionLoading = false;
      }).catch(({response}) => {
        Swal.fire({
          title: "Dosya Ekleme Başarısız",
          text: response.data.message,
          icon: "error",
          confirmButtonText: "Tamam",
        });
        this.fileActionLoading = false;
      });
    },

    onFileChange() {
      if (this.selectedFile) {
        const reader = new FileReader();
        reader.readAsDataURL(this.selectedFile);
      }
    },
    loadImages() {
      let files = this.singleStock.files;
      let imageTypes = ['jpeg', 'jpg', 'gif', 'png',"webp","svg","JPEG","JPG","GIF","PNG","WEBP","SVG","bmp","BMP","tiff","TIFF","ico","ICO","svgz","SVGZ","heif","HEIF","heic","HEIC","avif","AVIF","apng","APNG","jfif","JFIF","pjpeg","PJPEG","pjp","PJP","avif","AVIF","avifs","AVIFS"];
      let otherTypes = ['xlsx','pdf','PDF','csv','xls'];
      if (files) {
        let imageFiles = files.filter((item) => imageTypes.some(type => item.fileUrl.includes(type)));
        let otherFiles = files.filter((item) => otherTypes.some(type => item.fileUrl.includes(type)));
        for (let i = 0; i < imageFiles.length; i++) {
          this.picsumImages[i] = imageFiles[i].fileUrl;
        }
        for (let i = 0; i < otherFiles.length; i++) {
          this.otherLinks[i] = otherFiles[i].fileUrl;
        }
      } else {
        this.picsumImages = [];
        this.otherLinks = [];
      }
    },
    changeQuantity(type) {
      if (type === "add") {
        this.quantity++;
      } else if (type === "sub") {
        this.quantity--;
      }
    },
    goToSlide(index) {
      this.activeSlide = index;
    },
    expandImage(images) {
      this.$viewerApi({
        images: images,
      });
    },
    async addToCart(product, quantity = this.quantity) {
      product;
      if (!this.current) {
        Swal.fire({
          title: "Ürün Ekleme Başarısız",
          text: "Cari listesinden cari seçimi yapmalısınız",
          icon: "error",
          confirmButtonText: "Tamam",
        });
      } else {
        await this.stockToCartAdd({
          params: {
            userId: this.user.UserId,
            currentCode: this.current.code
          },
          body: {
            "StockCode": product.code,
            "Quantity": quantity,
            "Unit": 1,
            "Discount1": product.discount1,//Neye karşılık geliyor ?
            "Discount2": product.discount2,//Neye karşılık geliyor ?
            "isBasket": false,
            "Description": null
          }
        });
      }
    },
    async cartStockChange(product, quantity = 1) {
      if (!this.current) {
        Swal.fire({
          title: "Ürün Adet Güncelleme Başarısız",
          text: "Cari listesinden cari seçimi yapmalısınız",
          icon: "error",
          confirmButtonText: "Tamam",
        });
      } else {
        await this.cartStockUpdate({
          params: {
            userId: this.user.UserId,
            currentCode: this.current.code
          },
          body: {
            "Id": product.id,
            "StockCode": product.stockCode,
            "Quantity": quantity,
            "Discount1": product.discount1,//Neye karşılık geliyor ?
            "Discount2": product.discount2,//Neye karşılık geliyor ?
            "Unit": 1
          }
        });
      }
    },
    async cartStockRemove(product) {
      await this.cartStockDelete({
        params: {
          userId: this.user.UserId,
          currentCode: this.current.code,
          stockCode: product.code,
          //basketCode: null //sepet Kodu ise yollanacak
        },
        body: {}
      });
    },
    openMuadilKodDialog(data) {
      this.muadilKodDialogData = data;
      this.muadilKodDialog = true;
    },
    openStokOzellikDialog(data) {
      this.stokOzellikDialogData = data;
      this.stokOzellikDialog = true;
    },
    openStockActionListDialog(data) {
      this.stockCodeProp = data.code;
      //this.currentCodeProp = data.currentCode;
      this.showStockActionsDialog = true;
    },

    // async getMuadilKodluUrunList() {
    //   this.muadilKodluUrunList = await this.fetchStockList({
    //     params: {
    //       pageNumber: 1,
    //       pageSize: 10,
    //       userId: this.user.UserId,
    //     },
    //     body: {
    //       stock: this.singleStock.code,
    //       GenericCategories: null
    //     },
    //     onlyData: true,
    //     loading: false
    //   })
    //   this.searchStockLoading = false;
    // },

  },
  watch: {
    "stockCode": function (newVal) {
      this.fetchSingleStock({
        // Bu kısımda kişinin role groupuna göre parametre eklemesi yapılacaktır
        params: {
          userId: this.user.UserId,
          stockCode: newVal
        },
        body: {}
      });
    },
    "dialog": function (newVal) {
      this.$emit("dialogChange", newVal)
      if (newVal) {
        newVal;
      }

    },
    "showDialog": function (newVal) {
      this.dialog = newVal
    },
    "singleStock": function (newVal) {
      newVal;
      this.loadImages();
    }
  }
}
</script>

<style scoped>

</style>
